//@vendor
const Immutable = require('immutable');
const { handleActions } = require('redux-actions');
//@actions
const { simpleActions } = require('../actions/loanModifyAssociatedAccount');
//@constants
const { WIZARD_FIRST_STEP, WIZARD_SECOND_STEP, FIRST_STEP } = require('constants/index');

const setInitialState = () => Immutable.fromJS({
    steps: [
        { valid: false },
        { hasSignaturePattern: true }
    ],
    accountsInactive: false,
    currentAccountId: '',
    error: false,
    isFetching: false,
    newAccountId: '',
    newAccountIsDirty: false,
    submitSuccessful: false,
    visibleStep: 1
});

const validateStepOne = (state) => {
    const newAccountId = state.get('newAccountId');

    return state
        .setIn(['steps', FIRST_STEP, 'valid'], !!newAccountId)
        .merge({
            newAccountIsDirty: true,
            visibleStep: !!newAccountId ? WIZARD_SECOND_STEP : WIZARD_FIRST_STEP
        });
}

const validateStep = (state, currentStep) => {
    if (currentStep == WIZARD_FIRST_STEP) {
        return validateStepOne(state);
    }
}

const loanModifyAssociatedAccountReducer = handleActions(
    {
        [simpleActions.loanModifyAssociatedAccountReset]: state =>
            state.merge(setInitialState()),
        [simpleActions.loanModifyAssociatedAccountSetVisibleStep]: (state, action) =>
            state.merge({
                visibleStep: action.payload.currentStep
            }),
        [simpleActions.loanModifyAssociatedAccountValidateStep]: (state, action) =>
            validateStep(state, action.payload.currentStep),
        [simpleActions.loanModifyAssociatedAccountSetCurrentAccount]: (state, action) =>
            state.merge({
                currentAccountId: action.payload.response.currentAccountId,
                loanId: action.payload.response.loanId
            }),
        [simpleActions.loanModifyAssociatedAccountSetNewAccount]: (state, action) =>
            state.merge({
                newAccountId: action.payload.newAccountId
            }),
        [simpleActions.loanModifyAssociatedAccountInactive]: state =>
            state.merge({
                accountsInactive: true
            }),
        [simpleActions.loanModifyAssociatedAccount]: state =>
            state.merge({
                isFetching: true
            }),
        [simpleActions.loanModifyAssociatedAccountSuccess]: (state, action) =>
            state.merge({
                data: action.payload.response,
                isFetching: false,
                submitSuccessful: true
            }),
        [simpleActions.loanModifyAssociatedAccountError]: (state, action) =>
            state.merge({
                error: action.payload.error,
                isFetching: false,
                submitSuccessful: false
            })
    },
    setInitialState()
);

module.exports = loanModifyAssociatedAccountReducer;
module.exports.setInitialState = setInitialState;
